<template>
  <div class="section">
    <div class="content">
      <h1 :aria-label="$t('Accessibility')" class="title">
        {{ $t("Accessibility") }}
      </h1>
      <p
        class="content"
        v-for="(text, index) in $t('accessibility.content')"
        :aria-label="text"
        v-html="text"
      ></p>
      <h2 :aria-label="$t('accessibility.StateDigitalAccessibility.Title')">
        {{ $t("accessibility.StateDigitalAccessibility.Title") }}
      </h2>
      <p
        class="content"
        v-for="(text, index) in $t(
          'accessibility.StateDigitalAccessibility.content'
        )"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('accessibility.Non-accessible.Title')">
        {{ $t("accessibility.Non-accessible.Title") }}
      </h2>
      <h4 :aria-label="$t('accessibility.Non-accessible.contrast.Title')">
        {{ $t("accessibility.Non-accessible.contrast.Title") }}
      </h4>
      <p
        class="content"
        v-for="(text, index) in $t(
          'accessibility.Non-accessible.contrast.content'
        )"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h4
        :aria-label="$t('accessibility.Non-accessible.targetingContent.Title')"
      >
        {{ $t("accessibility.Non-accessible.targetingContent.Title") }}
      </h4>
      <p
        class="content"
        v-for="(text, index) in $t(
          'accessibility.Non-accessible.targetingContent.content'
        )"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h4 :aria-label="$t('accessibility.Non-accessible.language.Title')">
        {{ $t("accessibility.Non-accessible.language.Title") }}
      </h4>
      <p
        class="content"
        v-for="(text, index) in $t(
          'accessibility.Non-accessible.language.content'
        )"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h4 :aria-label="$t('accessibility.Non-accessible.name.Title')">
        {{ $t("accessibility.Non-accessible.name.Title") }}
      </h4>
      <p
        class="content"
        v-for="(text, index) in $t('accessibility.Non-accessible.name.content')"
        :aria-label="text"
      >
        {{ text }}
      </p>
      <h2 :aria-label="$t('accessibility.Feedback.Title')">
        {{ $t("accessibility.Feedback.Title") }}
      </h2>
      <p
        class="content"
        v-for="(text, index) in $t('accessibility.Feedback.content')"
        :aria-label="text"
        v-html="text"
      ></p>

<h2 :aria-label="$t('accessibility.Enforcement.Title')">
        {{ $t("accessibility.Enforcement.Title") }}
      </h2>
      <p
        class="content"
        v-for="(text, index) in $t('accessibility.Enforcement.content')"
        :aria-label="text"
        v-html="text"
      ></p>

      <address>
        <strong>{{ $t("accessibility.contact.title") }}</strong
        ><br />
        <span
          class="content"
          v-for="(text, index) in $t('accessibility.contact.adress')"
          :aria-label="text"
        >
          {{ text }}
          <br />
        </span>
        <a v-bind:href="$t('accessibility.contact.link')">{{
          $t("accessibility.contact.link")
        }}</a>
        <br />
        <a>{{ $t("accessibility.contact.mail") }}</a>
        <br />
        <span
          class="content"
          v-for="(text, index) in $t('accessibility.contact.number')"
          :aria-label="text"
        >
          {{ text }}
          <br />
        </span>
      </address>
      <!-- <Contact /> -->
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact.vue";

export default {
  components: { Contact },
};
</script>
